import { makeStringTemplate } from '@blockworks/platform';

const makeExecutionProxyUriGetter = (dashboardId: string) => {
    return makeStringTemplate(`/api/studio/dashboard/${dashboardId}/visualization/{visualizationId}/execution`);
};

export { makeExecutionProxyUriGetter };
